import { render } from "./FirstCut.vue?vue&type=template&id=5308ee2a&scoped=true"
import script from "./FirstCut.vue?vue&type=script&lang=js"
export * from "./FirstCut.vue?vue&type=script&lang=js"

import "./FirstCut.vue?vue&type=style&index=0&id=5308ee2a&scoped=true&lang=css"

import exportComponent from "/Users/liyunchen/Documents/Salute Project/BMW_4GC/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5308ee2a"]])

export default __exports__